import { inject } from 'mobx-react';
import Project from '@extensions/models/Project';
import ProjectPublications from '@extensions/components/project-search/ProjectPublications';
import { ProjectResult as DapProjectResult } from '@dapclient/components/project-search/ProjectResult';

export class ProjectResult extends DapProjectResult {
  getPublicationPanel = (hit: Project): React.ReactNode => {
    return this.getPanel({
      title: 'References',
      body: <ProjectPublications project={hit} tableSize="small" />,
    });
  };
}

export default inject((store: any) => ({
  // TODO: Put any services you need here
  // EXAMPLE => metricsService: store.metricsService
}))(ProjectResult);

